import React from 'react'
import clsx from 'clsx'
import {
  Container,
  createStyles,
  Grid,
  makeStyles,
  Typography,
  Theme,
} from '@material-ui/core'
import CMSText from '../Global/CMSText'
import ProductCard from '../Shop/ProductCard'
import ProductCardSkeleton from '../Global/ProductCardSkeleton'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    packProductTitle: {
      marginBottom: theme.spacing(3),
    },
    relatedTitle: {
      margin: theme.spacing(0, 0, 2),
    },
    col: {},
    md5: {
      [theme.breakpoints.up('lg')]: {
        maxWidth: '20%',
        flexBasis: '20%',
      },
    },
    associationRow: {
      marginBottom: theme.spacing(3),
    },
  })
)

type Tprops = {
  packs: any
  associations: any
  relatedProductsTitle: any
  aspectRatio: string
  gridItemWidth: any
  isFiveColumns: boolean
  t: any
  cardWidth: number
  promotions: any
  generalRes: any
  singleProductRes: any
  stock: any
  addToCartButtonOnAssociatedItem: boolean
}

const PackRelatedProducts = ({
  associations,
  packs,
  relatedProductsTitle,
  aspectRatio,
  gridItemWidth,
  isFiveColumns,
  t,
  generalRes,
  cardWidth,
  singleProductRes,
  stock,
  addToCartButtonOnAssociatedItem,
  promotions,
}: Tprops) => {
  const relatedProductsClasses = useStyles()
  return (
    <Container maxWidth={'xl'}>
      <div className={clsx('pack-related')}>
        {Object.keys(associations).length > 0 && (
          <>
            <Typography
              variant={'h3'}
              component={'h2'}
              className={clsx(
                'pack-related__title',
                relatedProductsClasses.relatedTitle
              )}
            >
              {!packs.loading && (
                <CMSText
                  asText
                  data={relatedProductsTitle}
                  defaultText={t('texts:single_product:associations_title')}
                />
              )}
            </Typography>
            {!packs.loading ? (
              associations?.map((association, index) => {
                return (
                  <Grid
                    key={index}
                    container
                    spacing={3}
                    className={relatedProductsClasses.associationRow}
                  >
                    {association.products.map((relatedProduct, index) => {
                      return (
                        <Grid
                          item
                          xs={6}
                          key={index}
                          lg={isFiveColumns ? 2 : gridItemWidth}
                          className={
                            isFiveColumns
                              ? relatedProductsClasses.md5
                              : relatedProductsClasses.col
                          }
                        >
                          <ProductCard
                            settings={generalRes}
                            stock={stock}
                            text={singleProductRes}
                            productCode={relatedProduct.code}
                            slug={relatedProduct.slug}
                            name={relatedProduct.name}
                            thumb={relatedProduct?.images[0]}
                            thumbRatio={aspectRatio}
                            thumbWidth={cardWidth}
                            product={relatedProduct}
                            addButton={addToCartButtonOnAssociatedItem}
                            isRelated={true}
                            promotions={promotions}
                            fromPack
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                )
              })
            ) : (
              <ProductCardSkeleton
                isFiveColumns={isFiveColumns}
                gridItemWidth={gridItemWidth}
                aspectRatio={aspectRatio}
              />
            )}
          </>
        )}
      </div>
    </Container>
  )
}

export default PackRelatedProducts
